// extracted by extract-css-chunks-webpack-plugin
module.exports = {"duplicity-info":"duplicityinfo__duplicity-info--3PqIx","duplicityInfo":"duplicityinfo__duplicity-info--3PqIx","list":"duplicityinfo__list--1r39b"};